import { BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";
import { Home } from "./pages/home/home";
import './App.css';
import Xodim from "./pages/xodimlar/xodim";
import Mamuriyat from "./pages/mamuriyat/mamuriyat";
import Head from "./pages/layouts/head";
import Foot from "./pages/layouts/foot";
import Yangilik from "./pages/yangiliklar/yangilik";
import Malaka from "./pages/malaka tavsifnomasi";
import Talablar from "./pages/malaka talablari";
import Oquv_reja from "./pages/oquv_rejalar";

function App() {
  return (
    <Router>
        <div className="App">
          <Head/>
          <Routes>
            <Route exact path='/' element={<Home/>} />
            <Route path='/xodim' element={<Xodim/>} />
            <Route path='/oquv_reja' element={<Oquv_reja/>} />
            <Route path='/mamuriyat' element={<Mamuriyat/>} />
            <Route path='/yangilik' element={<Yangilik/>} />
            <Route path='/malaka_tavsifnoma' element={<Malaka/>} />
            <Route path='/malaka_talablari' element={<Talablar/>} />
          </Routes>
          <Foot/>
        </div>
    </Router>
  );
}

export default App;
